/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * if true - required api is called on payment page
 * @param {*} state
 * @returns true || false
 */
export const getPaymentPageReady = (state) => state.mfeCheckout.payment.paymentReadiness.pageReady;

export default {};
